import React, { FC, useCallback } from 'react';
import { toast } from 'react-toastify';

import {
  FundProfileShowPageQuery,
  useToggleFundProfileAdminMutation
} from '@interfaces/graphql-typings';

import styles from './fundProfileAdminsStyles.scss';

const FundProfileAdmins: FC<{
  currentEmployees: NonNullable<FundProfileShowPageQuery['fundProfile']>['currentEmployees'];
  currentUserId: string;
  fundAdminIds: string[];
  fundProfileId: string;
}> = ({ currentEmployees, currentUserId, fundAdminIds, fundProfileId }) => {
  const [toggleFundProfileAdmin, { loading }] = useToggleFundProfileAdminMutation();

  const handleToggleFundProfileAdmin = useCallback(
    (employeeId: string) => {
      toggleFundProfileAdmin({
        variables: { currentEmployeeId: employeeId, employerProfileId: fundProfileId }
      })
        .then(() => toast.success('Fund admin updated', { autoClose: 2500, theme: 'colored' }))
        .catch(error => toast.error(error.message, { autoClose: 5000, theme: 'colored' }));
    },
    [fundProfileId, toggleFundProfileAdmin]
  );

  return (
    <div className={styles.fundProfileAdmins}>
      <h5>Fund Admins</h5>
      <div className={styles.fundProfileAdminsList}>
        {currentEmployees.map(employee => (
          <label
            key={employee.id}
            className={styles.fundProfileAdminsListItem}
            htmlFor={employee.id}
          >
            {employee.displayName}
            {currentUserId === employee.id ? ' (You)' : null}
            <input
              checked={fundAdminIds.includes(employee.id)}
              disabled={currentUserId === employee.id || loading}
              id={employee.id}
              name="fundAdminIds"
              onChange={() => handleToggleFundProfileAdmin(employee.id)}
              type="checkbox"
            />
          </label>
        ))}
      </div>
    </div>
  );
};

export default FundProfileAdmins;
